import { render } from "./DescriptionInitiativePage.vue?vue&type=template&id=679e8c35&scoped=true"
import script from "./DescriptionInitiativePage.vue?vue&type=script&lang=js"
export * from "./DescriptionInitiativePage.vue?vue&type=script&lang=js"

import "./DescriptionInitiativePage.vue?vue&type=style&index=0&id=679e8c35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679e8c35"]])

export default __exports__